// frontend/src/components/fields/CountrySelect.jsx

import React from 'react';
import COUNTRY_LIST from '../../config/countries.json';
import { toTitleCase } from '../../utils/formatters';

export default function CountrySelect({
  name = 'nationality',
  value = '',
  onChange,
  disabled = false,
  className = 'input-inline w-full',
  includeEmpty = true
}) {
  // Opciones formateadas (misma lógica que el modal)
  const options = COUNTRY_LIST.map(({ code, name }) => ({
    value: code,
    label: toTitleCase(name)
  }));

  return (
    <select
      name={name}
      value={value || ''}
      onChange={onChange}
      disabled={disabled}
      className={className}
      autoComplete="off"
    >
      {includeEmpty && <option value="">—</option>}
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
